import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'; // Adjust path if needed
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if user has valid token, then check admin role
  const hasValidToken = authService.getToken() !== null;
  
  if (!hasValidToken) {
    console.warn('AdminGuard: No valid token. Redirecting to login.');
    router.navigate(['/login']);
    return false;
  }
  
  const isAdmin = authService.isAdmin();
  
  if (isAdmin) {
    return true; // Allow access if user is admin
  } else {
    // If user is logged in but not admin, redirect them
    console.warn('AdminGuard: User is not admin. Redirecting to dashboard.');
    router.navigate(['/dashboard']); // Redirect to the main dashboard page
    return false; // Prevent access to the admin route
  }
};